module.exports = __webpack_public_path__ + "img/tsa-connect-logo-mobile.a47ccdf2.jpg";